<script>
  const img_step01 = "/assets_default/images/service/loan/guide/increase/service_loan_increase_step_01.webp"
  const img_step02 = "/assets_default/images/service/loan/guide/increase/service_loan_increase_step_02.webp"
</script>

  <page-header text="増枠"></page-header>
  <keyvisual-content
    title="お金が足りないときも<br>すぐに追加で借りられる"
    image="/assets_default/images/service/loan/guide/increase/service_loan_increase_kv.webp"
  >
  </keyvisual-content>
  <section class="owd-section spacing:bottom:64">
    <p class="owd-text:01">利用可能額の増枠は、ローンの契約後でもアプリからかんたんに申込みできます。利用可能額を増やすことで、急な出費に備えることが可能です。</p>
  </section>
  <section class="owd-section spacing:bottom:64">
    <h2 class="owd-heading:03 align:center spacing:bottom:40">利用までの流れ</h2>
    <div class="spacing:bottom:40">
      <div class="owd-section-header spacing:bottom:40">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 01</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">増枠をタップ</h2>
        <p class="owd-text:01 spacing:bottom:24">Banking画面内の「ローン」タブを選択後、「Loan」内の「増枠」をタップします。</p>
        <div class="owd-img-area">
          <img src={img_step01} width="310" height="174" alt="増枠をタップ">
        </div>
      </div>
      <div class="owd-section-header">
        <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en spacing:bottom:16">
          <span class="owd-label:en owd-servicesticker-label">STEP 02</span>
        </div>
        <h2 class="owd-heading:03 spacing:bottom:24">申込み</h2>
        <p class="owd-text:01 spacing:bottom:24">画面の指示に従って、増枠の申込みをします。</p>
        <div class="owd-img-area">
          <img src={img_step02} width="310" height="174" alt="申込み">
        </div>
      </div>
    </div>
    <div class="show:sp">
      <div class="block:center spacing:bottom:16">
        <a href="https://minna-no-ginko.go.link/?tp=pg&pg=bl&adj_t=1t72r13o" class="owd-button owd-button:large owd-button:primary">アプリで確認する</a>
      </div>
      <p class="owd-information align:center"><strong>※アプリをお持ちでない方は、ストアに遷移します。</strong></p>
    </div>
  </section>
